var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-3" },
    [
      _c(
        "b-card",
        { attrs: { title: "Edit Pengumuman" } },
        [
          _c("b-card-text", [
            _c("form", { staticClass: "mt-5" }, [
              _c("div", { staticClass: "form-group row pb-4" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-lg-3 text-lg-end pt-2",
                    attrs: { for: "select-poli" },
                  },
                  [_vm._v("Judul")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.judul,
                        expression: "form.judul",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.form.judul },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form, "judul", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row pb-4" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-lg-3 text-lg-end pt-2",
                    attrs: { for: "select-poli" },
                  },
                  [_vm._v("Isi")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.isi,
                        expression: "form.isi",
                      },
                    ],
                    staticClass: "form-control",
                    domProps: { value: _vm.form.isi },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form, "isi", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row pb-4" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-lg-3 text-lg-end pt-2",
                    attrs: { for: "select-poli" },
                  },
                  [_vm._v("Status")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.status,
                          expression: "form.status",
                        },
                      ],
                      staticClass: "form-select",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.form,
                            "status",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c("option", { attrs: { value: "null" } }, [
                        _vm._v("--- Pilih Pengumuman ---"),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "1" } }, [
                        _vm._v("Aktif"),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "0" } }, [
                        _vm._v("Tidak Aktif"),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row pb-4" }, [
                _c("div", { staticClass: "col-lg-3 text-lg-end pt-2" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn-sm",
                        attrs: { variant: "primary" },
                        on: { click: _vm.simpanPengumuman },
                      },
                      [_vm._v("Simpan")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn-sm",
                        attrs: { variant: "danger" },
                        on: { click: _vm.cancelAdd },
                      },
                      [_vm._v("Batal")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }